var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "18px",
    viewBox: "0 0 21 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8A7D9F9D-BE76-4207-BE05-E6E8B3AF1508") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2-0-TMR-FRTB-SA",
    transform: "translate(-20.000000, -368.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav",
    transform: "translate(0.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Jobs-Icon",
    transform: "translate(21.000000, 262.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "currentColor",
    strokeWidth: 2,
    points: "12.26914 3.1541502 0.0730047203 3.1541502 0.0730047203 15.8893181 16.3025149 15.8893181 16.3025149 8.56126482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59457174,6.26246884 C3.94471667,6.26246884 3.41794855,6.78923696 3.41794855,7.43922971 C3.41794855,8.08908478 3.94471667,8.6158529 4.59457174,8.6158529 C5.24442681,8.6158529 5.77119493,8.08908478 5.77119493,7.43922971 C5.77119493,6.78923696 5.24442681,6.26246884 4.59457174,6.26246884",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59457174,10.5633942 C3.94471667,10.5633942 3.41794855,11.0903 3.41794855,11.7401551 C3.41794855,12.3900101 3.94471667,12.9169159 4.59457174,12.9169159 C5.24442681,12.9169159 5.77119493,12.3900101 5.77119493,11.7401551 C5.77119493,11.0903 5.24442681,10.5633942 4.59457174,10.5633942",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    stroke: "currentColor",
    strokeWidth: 2,
    points: "9.34500511 5.74072925 13.0383265 8.56126482 18.7111611 0.202188026"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.ca1b3a72.svg";
export { ForwardRef as ReactComponent };